import { useState, useMemo, useEffect } from 'react';
import { useQueryParams } from '@/hooks';
import { LogisticOperatorsFilter } from '../models';
import { LogisticOperatorStatus } from '../enums';

export function useLogisticOperatorsFilter() {
  const { getQueryParam, setQueryParams } = useQueryParams();

  const initialFilter: LogisticOperatorsFilter = useMemo(() => ({}), []);

  const [filters, setFilters] = useState<LogisticOperatorsFilter>(() => ({
    name: getQueryParam('name') || undefined,
    businessName: getQueryParam('businessName') || undefined,
    selectedOperatorIdFromName:
      getQueryParam('selectedOperatorIdFromName') || undefined,
    selectedOperatorIdFromBusiness:
      getQueryParam('selectedOperatorIdFromBusiness') || undefined,
    status: (getQueryParam('status') as LogisticOperatorStatus) || undefined,
  }));

  useEffect(() => {
    setQueryParams({
      name: filters.name || undefined,
      businessName: filters.businessName || undefined,
      selectedOperatorIdFromName:
        filters.selectedOperatorIdFromName || undefined,
      selectedOperatorIdFromBusiness:
        filters.selectedOperatorIdFromBusiness || undefined,
      status: filters.status || undefined,
    });
  }, [filters]);

  return {
    filters,
    setFilters,
    initialFilter,
  };
}
